import { filterPartiallySatisfiedCaseSizeRules } from "@sellar-io/common";
import type { BasketOrderItem } from "../../../hooks";
import type { SupplierStorefrontInfo } from "../UnifiedCheckoutProvider.shared";
import { isPromotionalOrderItem } from "../../stockList/categoryPage/Storefront/StorefrontPromotion/isPromotionalOrderItem";

export const getIncompleteUnifiedCheckoutCaseSizeRules = ({
  orderItems,
  storefront,
}: {
  orderItems: BasketOrderItem[];
  storefront: SupplierStorefrontInfo["storefront"] | null | undefined;
}) => {
  if (!storefront?.CaseSizeRules.enforced) return [];

  return filterPartiallySatisfiedCaseSizeRules({
    caseSizeRuleList: storefront.CaseSizeRules.list,
    orderItemList: orderItems
      .filter((item) => !isPromotionalOrderItem(item))
      .map((item) => ({
        quantity: item.quantity,
        containerType: item.Product.containerType ?? null,
        volume: item.Product.volume ?? null,
        unit: item.Product.unit ?? null,
        packQuantity: item.Product.packQuantity ?? null,
      })),
  });
};
